export const darkTemplate = {
	primary: '#2d2d3b',
	secondary: '#1f1f2d',
	text: '#f3f3f6',
};
